/*
 * shopify-form-style.js — style the footer Shopify Forms newsletter (ID 1056338)
 * to match the site. Shopify Forms renders in a SHADOW DOM, so theme CSS can't
 * reach it; this injects a <style> into the form's shadow root (and, as a
 * fallback, the document head in case the form is in the light DOM). It uses the
 * theme's own CSS custom properties, which inherit through the shadow boundary,
 * so the heading matches .footer-block__heading exactly.
 */
(function () {
  'use strict';

  var CSS =
    // Heading — match the footer link-list headings (.footer-block__heading)
    '[class*="_formContainer"] [class*="_textHeading"]{' +
      'font-family:var(--font-heading-family)!important;' +
      'font-weight:var(--font-heading-weight)!important;' +
      'font-size:calc(var(--font-heading-scale)*1.6rem)!important;' +
      'letter-spacing:calc(var(--font-heading-scale)*0.06rem)!important;' +
      'line-height:1.3!important;text-align:left!important;' +
      'padding-bottom:15px!important;' +
      'color:rgb(var(--color-foreground))!important;}' +
    '@media(min-width:990px){[class*="_formContainer"] [class*="_textHeading"]{' +
      'font-size:calc(var(--font-heading-scale)*1.8rem)!important;}}' +
    // Left-align heading, subheading and disclaimer
    '[class*="_formContainer"] [class*="_textBody"],' +
    '[class*="_formContainer"] [class*="_formHeader"],' +
    '[class*="_formContainer"] [class*="_formDisclaimer"]{text-align:left!important;}' +
    // Remove top margins so the form sits flush with the top of the column
    '[class*="_formContainer"]{margin-top:0!important;}' +
    '[class*="_formContainer"] [class*="_formHeader"]{margin-top:0!important;margin-bottom:10px!important;}' +
    // Square every field + button
    '[class*="_formContainer"] input,' +
    '[class*="_formContainer"] button,' +
    '[class*="_formContainer"] [class*="_selectToggle"]{border-radius:0!important;}' +
    // Mobile: remove the form's left indent so it lines up with the footer link headings
    '@media(max-width:749px){' +
      '[class*="_formContainer"]{padding-left:0!important;padding-right:0!important;margin-left:0!important;}' +
      '[class*="_gridItemContent"]{padding-left:0!important;padding-right:0!important;}' +
      '[class*="_grid"]{grid-template-columns:1fr!important;column-gap:0!important;}' +
    '}';

  var STYLE_ID = 'shwink-form-style';

  function alreadyHas(target) {
    try { return !!target.querySelector('#' + STYLE_ID); } catch (e) { return false; }
  }
  function addStyleTo(target) {
    if (!target || alreadyHas(target)) return false;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = CSS;
    target.appendChild(s);
    return true;
  }

  // Recursively find open shadow roots that hold the form, and style them.
  function styleShadowForms(node, depth) {
    if (!node || depth > 6) return false;
    var injected = false;
    var els = node.querySelectorAll ? node.querySelectorAll('*') : [];
    for (var i = 0; i < els.length; i++) {
      var sr = els[i].shadowRoot;
      if (!sr) continue;
      if (sr.querySelector('[class*="_formContainer"], [class*="_textHeading"]')) {
        if (addStyleTo(sr)) injected = true;
      }
      if (styleShadowForms(sr, depth + 1)) injected = true;
    }
    return injected;
  }

  var iv, obs, tries = 0;
  function stop() { if (iv) clearInterval(iv); if (obs) obs.disconnect(); }

  function run() {
    addStyleTo(document.head); // light-DOM fallback (harmless if the form is shadowed)
    if (styleShadowForms(document, 0)) stop(); // stop once a shadow form is styled
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  // The Shopify Forms JS renders the form asynchronously — retry briefly + observe.
  iv = setInterval(function () { run(); if (++tries >= 20) stop(); }, 400);
  try {
    obs = new MutationObserver(run);
    obs.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
